import Axios from "axios";
import { useAsync, AsyncState } from "react-async-hook";

import ENDPOINTS from "utils/endpoints";

export type CreditCardInfo = {
    brand: string;
    last4: string;
    expMonth: number;
    expYear: number;
};

export default function useCardPlaceholder(): AsyncState<CreditCardInfo | null> {
    const loadCardInfo = useAsync(async () => {
        const { data } = await Axios.get<{ cardData: CreditCardInfo } | null>(
            ENDPOINTS.CARD_INFO
        );
        return data?.cardData ?? null;
    }, []);

    return loadCardInfo;
}
